import { render, staticRenderFns } from "./BatteryAiAssistant.vue?vue&type=template&id=34d51ac2&scoped=true"
import script from "./BatteryAiAssistant.vue?vue&type=script&lang=js"
export * from "./BatteryAiAssistant.vue?vue&type=script&lang=js"
import style0 from "./BatteryAiAssistant.vue?vue&type=style&index=0&id=34d51ac2&prod&scoped=true&lang=css"
import style1 from "./BatteryAiAssistant.vue?vue&type=style&index=1&id=34d51ac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d51ac2",
  null
  
)

export default component.exports